import { Search as SearchIcon, X } from 'lucide-react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type SearchProps = {
  onSearch: (e: any) => void;
  placeholder: string;
  className?: string;
  customInput?: string;
  defaultValue?: string;
};

type SimpleSearchProps = {
  onSearch: (e: any) => void;
  placeholder: string;
  className?: string;
  customInput?: string;
  value?: string;
};

type SearchFollowChangeProps = {
  onSearch: (e: any) => void;
  placeholder: string;
  setFunc: Dispatch<SetStateAction<string>>;
};

type EdgedSearchProps = {
  onSearch: (e: any) => void;
  placeholder: string;
  style?: React.CSSProperties;
};

export function Search({
  onSearch,
  placeholder,
  className,
  customInput,
  defaultValue,
}: SearchProps) {
  const [text, setText] = useState('');
  const { t } = useTranslation();
  const handleSearch = () => {
    onSearch(text);
  };
  return (
    <div
      className={`flex items-center justify-between appearance-none h-[40px] w-[280px] pr-3 rounded border border-solid border-gray-300 hover:border-[#f17a20] ${className}`}
    >
      <input
        onChange={(e: any) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
        defaultValue={defaultValue}
        placeholder={placeholder}
        className={`ml-5 border-none rounded focus:outline-none placeholder-[#CCCED1] placeholder:text-sm placeholder:text-gray-400 w-full  ${customInput}`}
      />
      <SearchIcon
        className='text-primary cursor-pointer'
        size={18}
        onClick={handleSearch}
      />
    </div>
  );
}

export function SearchFollowChange({
  onSearch,
  placeholder,
  setFunc,
  className,
  customInput,
}: SearchFollowChangeProps & { className?: string; customInput?: string }) {
  const [text, setText] = useState('');

  const handleSearch = () => {
    onSearch(text);
  };

  const handleChange = (value: any) => {
    setText(value);
    setFunc(value);
  };

  return (
    <div
      className={`flex items-center justify-between appearance-none h-[40px] w-[280px] pr-3 rounded border border-solid border-[#e3e3e3] hover:border-[#f17a20] ${className}`}
    >
      <input
        onChange={(e: any) => handleChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
        value={text}
        placeholder={placeholder}
        className={`ml-5 border-none rounded focus:outline-none placeholder-[#CCCED1] placeholder:text-sm w-full ${customInput}`}
      />
      <SearchIcon
        className='text-primary cursor-pointer'
        size={18}
        onClick={handleSearch}
      />
    </div>
  );
}



export function EdgedSearch({
  onSearch,
  placeholder,
  style,
}: EdgedSearchProps) {
  const [text, setText] = useState('');
  const { t } = useTranslation();
  const handleSearch = () => {
    onSearch(text);
  };
  return (
    <div
      className='flex items-center appearance-none h-[40px] pr-3 rounded border border-gray-300'
      style={style}
    >
      <SearchIcon
        className='text-blue-500 ml-3 cursor-pointer'
        size={18}
        onClick={handleSearch}
      />
      <input
        onChange={(e: any) => setText(e.target.value)}
        placeholder={placeholder}
        className='focus:outline-none px-3 placeholder-gray-400 placeholder:text-sm'
      />
    </div>
  );
}

export function SimpleSearch({
  onSearch,
  placeholder,
  className,
  customInput,
  value,
}: SimpleSearchProps) {
  const [text, setText] = useState(value || '');
  const { t } = useTranslation();

  useEffect(() => {
    setText(value || '');
  }, [value]);

  const handleSearch = () => {
    onSearch(text);
  };

  const handleClear = () => {
    setText('');
    onSearch('');
  };

  return (
    <div
      className={`flex items-center justify-between appearance-none h-[40px] w-[280px] rounded border border-solid border-[#e3e3e3] ${className}`}
    >
      <input
        value={text}
        onChange={(e: any) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
        placeholder={placeholder}
        className={`ml-5 flex-1 border-none rounded focus:outline-none placeholder-[#CCCED1] placeholder:text-sm ${customInput}`}
      />
      <div className='flex items-center px-2'>
        {text && (
          <X
            size={16}
            className='text-gray-400 hover:text-gray-600 cursor-pointer mr-2'
            onClick={handleClear}
          />
        )}
        <SearchIcon
          className='text-primary cursor-pointer'
          size={18}
          onClick={handleSearch}
        />
      </div>
    </div>
  );
}
